import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize'
import ShareIcon from '@material-ui/icons/Share'
import { Pagination } from '@material-ui/lab'
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import ShareDialog from 'components/Dialog/ShareDialog'
import saveAs from 'file-saver'
import {
  useGetCompanyQuery,
  useGetShareAttachmentMutation,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import * as htmlToImage from 'html-to-image'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import ELetterPreview from './ELetterTemplate/ELetterPreview'
import './PDFStyle.scss'
import { useQueries } from './Query/useQueries'

export const PDFPreviewV2 = (props: any) => {
  const { accountType, docType } = props
  let history = useHistory()
  let location = useLocation()

  const locationState = location?.state || null
  const {
    CompanyID,
    InvoiceID,
    ReceiptID,
    CreditNoteID,
    DebitNoteID,
    PaymentID,
    AdvanceID,
    RefundID,
    BatchPaymentID,
  }: any = useParams()

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [page, setCurrentPage] = useState(0)
  const [pageLength, setPageLength] = useState(1)
  const [remapData, setRemapData] = useState([])

  const [width, height] = useMediaQuery()

  const {
    loading: companyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getCompany }) => {
      setLabelState(getCompany[0]?.Name)
    },
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  let routeSegments
  let title
  let smallTitle
  let creditorOrDebtor
  let name
  let DocumentID
  let itemName
  let hasItem: boolean
  switch (accountType) {
    case 'account-receivable':
      smallTitle = smTitle.ACCOUNT_RECEIVABLE
      creditorOrDebtor = 'DebtorAccount'
      name = 'DebtorName'
      switch (docType) {
        case 'official-receipt':
          DocumentID = ReceiptID
          routeSegments = 'Official Receipt'
          title = 'OFFICIAL RECEIPT'
          itemName = 'Allocation'
          hasItem = true
          break
        case 'refund':
          DocumentID = RefundID
          routeSegments = 'Refund'
          title = 'REFUND VOUCHER'
          itemName = 'Allocation'
          hasItem = true
          break
        case 'invoice':
          DocumentID = InvoiceID
          routeSegments = 'Invoice'
          title = 'INVOICE'
          itemName = 'ARInvoiceItem'
          hasItem = true
          break
        case 'credit-note':
          DocumentID = CreditNoteID
          routeSegments = 'Credit Note'
          title = 'CREDIT NOTE'
          itemName = 'ARCreditNoteItem'
          hasItem = true
          break
        case 'debit-note':
          DocumentID = DebitNoteID
          routeSegments = 'Debit Note'
          title = 'DEBIT NOTE'
          itemName = 'ARDebitNoteItem'
          hasItem = true
          break
        case 'advance':
          DocumentID = AdvanceID
          routeSegments = 'Advance'
          title = 'ADVANCE'
          itemName = 'Allocation'
          hasItem = true
          break
      }
      break
    case 'account-payable':
      smallTitle = smTitle.ACCOUNT_PAYABLE
      creditorOrDebtor = 'CreditorAccount'
      name = 'CompanyName'
      switch (docType) {
        case 'payment':
          DocumentID = PaymentID
          routeSegments = !!BatchPaymentID ? 'Batch Payment' : 'Payment'
          title = 'PAYMENT VOUCHER'
          itemName = 'APPaymentItem'
          hasItem = true
          break
        case 'advance':
          DocumentID = AdvanceID
          routeSegments = 'Advance'
          title = 'ADVANCE VOUCHER'
          hasItem = false
          break
        case 'refund':
          DocumentID = RefundID
          routeSegments = 'Refund'
          title = 'REFUND VOUCHER'
          itemName = 'Allocation'
          hasItem = true
          break
        case 'invoice':
          DocumentID = InvoiceID
          routeSegments = 'Invoice'
          title = 'INVOICE'
          itemName = 'APInvoiceItem'
          hasItem = true
          break
        case 'credit-note':
          DocumentID = CreditNoteID
          routeSegments = 'Debit Adjustment'
          title = 'CREDIT NOTE'
          itemName = 'APCreditNoteItem'
          hasItem = true
          break
        case 'debit-note':
          DocumentID = DebitNoteID
          routeSegments = 'Credit Adjustment '
          title = 'DEBIT NOTE'
          itemName = 'APDebitNoteItem'
          hasItem = true
          break
      }
      break
  }

  const { loading, listData, templateBody } = useQueries({
    accountType,
    docType,
    CompanyID,
    ReceiptID,
    DocumentID: DocumentID,
    setErrMessage,
    setErrDialog,
  })

  const previewDetail: any = {
    ...listData[0],
    ...(hasItem && {
      itemList: listData[0]?.[itemName],
      [itemName]: listData[0]?.[itemName] ?? [],
    }),
  }

  /// ========== kendo-drawing PDF Download ===========
  const dataURItoFile = (dataurl, filename) => {
    dataurl.replace('data:application/pdf;base64,', '')
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const onPrint = () => {
    let element = document.getElementById('pdf-data-print')

    drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })
      .then((group: Group) => exportPDF(group))
      .then(dataURI => {
        let fileObject = dataURItoFile(
          dataURI,
          `${title} (${previewDetail?.DocNo}).pdf`
        )
        saveAs(fileObject, `${title} (${previewDetail?.DocNo}).pdf`)
      })
  }

  const onShare = async (filename = 'document.pdf') => {
    const element = document.getElementById('pdf-data-print')

    const group = await drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })

    const dataURI = await exportPDF(group)

    // Convert Base64 → Blob
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = 'application/pdf'
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    const blob = new Blob([ab], { type: mimeString })

    // ✅ Return a File object with PDF type
    const file = new File([blob], filename, { type: mimeString })
    return file
  }

  const pdfToPrint = () => {
    return (
      <>
        {/* ========================================= */}
        {/* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */}
        {/* ========================================= */}
        <div style={{ position: 'fixed', left: `-2000px` }}>
          <div id={'pdf-data-print'}>
            {
              <ELetterPreview
                title={title}
                previewDetail={previewDetail}
                accountType={accountType}
                docType={docType}
                itemName={itemName}
                creditorOrDebtor={creditorOrDebtor}
                getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                page={page}
                pageLength={pageLength}
                setPageLength={setPageLength}
                hasItem={hasItem}
                currencyCode={getCompany[0]?.Currency?.code}
                htmlTemplate={templateBody}
                remapData={remapData}
                setRemapData={setRemapData}
              />
            }
          </div>
        </div>
      </>
    )
  }

  const [labelState, setLabelState] = useState<string>()

  const [openShareDialog, setOpenShareDialog] = useState(false)
  const [openSendEmail, setOpenSendEmail] = useState(false)

  const [
    getShareAttachments,
    {
      data: { getShareAttachment } = { getShareAttachment: {} as any },
      loading: ShareAttachmentLoading,
    },
  ] = useGetShareAttachmentMutation({
    onCompleted: () => {
      setOpenShareDialog(true)
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const onSubmit = blob => {
    getShareAttachments({
      variables: { file: blob, CompanyID },
    })
  }

  return (
    <>
      {loading && <Loading />}
      {UserLoading && <Loading />}
      {companyLoading && <Loading />}
      {ShareAttachmentLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          !!BatchPaymentID
            ? history.push({
                pathname: `/${accountType}/${CompanyID}/batch-payment/${BatchPaymentID}/detail`,
                state: previewDetail,
              })
            : previewDetail?.ApprovalStatus === 'COMPLETED'
            ? history.push({
                pathname: `/${accountType}/${CompanyID}/${docType}/${DocumentID}/detail`,
                state: locationState !== null ? locationState : previewDetail,
              })
            : history.push({
                pathname: `/${accountType}/${CompanyID}/${docType}`,
                state: locationState !== null ? locationState : previewDetail,
              })
        }}
        smTitle={smallTitle}
        title={getCompany[0]?.Name}
        routeSegments={[
          { name: `${smTitle}` },
          { name: `${routeSegments}` },
          { name: `${routeSegments}`, current: true },
        ]}
        rightRouteSegments={[{ name: `Print`, current: true }]}
      />
      <ContentWrapper footer>
        <div>
          {previewDetail && (
            <ELetterPreview
              title={title}
              previewDetail={previewDetail}
              accountType={accountType}
              docType={docType}
              itemName={itemName}
              creditorOrDebtor={creditorOrDebtor}
              getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
              hasItem={hasItem}
              currencyCode={getCompany[0]?.Currency?.code}
              htmlTemplate={templateBody}
              isView={true}
              page={page}
              pageLength={pageLength}
              setPageLength={setPageLength}
              remapData={remapData}
              setRemapData={setRemapData}
            />
          )}
        </div>
        <div
          className={
            width < 769 ? 'pagination-dis-mobile' : 'pagination-dis-desktop'
          }
        >
          <Pagination
            count={pageLength}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1)
            }}
          />
        </div>
      </ContentWrapper>
      {ShareDialog({
        shareTitle: `${smallTitle} - ${labelState}`,
        title: `Share`,
        URL: getShareAttachment?.fileURL,
        setSimple: setOpenShareDialog,
        simple: openShareDialog,
        emailShare: openSendEmail,
        setSimpleEmail: setOpenSendEmail,
      })}
      <Footer
        options={[
          {
            name: 'Share',
            onClick: async () => {
              // const temp = document.getElementById('pdf-data-print')

              // if (!temp) {
              //   return
              // }

              // try {
              //   const blob = await htmlToImage.toBlob(temp, {
              //     style: { background: '#fff' },
              //     cacheBust: true,
              //     filter: node => {
              //       if (node.tagName === 'IMG') {
              //         const img = node as HTMLImageElement
              //         if (!img.complete || img.naturalHeight === 0) {
              //           return false
              //         }
              //       }
              //       return true
              //     },
              //     skipFonts: false,
              //   })

              //   onSubmit(blob)
              // } catch (error) {
              //   setErrMessage(
              //     'Failed to generate shareable image. Please try again.'
              //   )
              //   setErrDialog(true)
              // }
              onSubmit(await onShare())
            },
            color: 'primary',
            props: {
              type: 'submit',
            },
            startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
          },
          {
            name: 'Download',
            onClick: () => {
              onPrint()
            },
            color: 'primary',
          },
        ]}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      <div style={{ width: 1980 }}>{pdfToPrint()}</div>
    </>
  )
}
